/** What a user may type in the PhoneField local part: digits, spaces, dashes, parentheses. */
export function isValidPhoneInput(value) {
  return /^[0-9\s\-()]{6,15}$/.test(String(value ?? '').trim());
}

/**
 * Builds the international number kio-api stores ('+213555123456') from a
 * PhoneField dial code ('+213', '+1 US') and a local number in any common
 * format ('0555 12 34 56', '555-12-34-56', or a pasted '213 555 12 34 56').
 */
export function toInternationalPhone(dialCode, localNumber) {
  const dial = String(dialCode ?? '').replace(/\D/g, '');
  let national = String(localNumber ?? '').replace(/\D/g, '').replace(/^0+/, '');
  // A pasted number that already carries the country code: drop it only when a
  // full national number (8+ digits) follows, so short local numbers that merely
  // start with the same digits are kept.
  if (dial && national.startsWith(dial) && national.length - dial.length >= 8) {
    national = national.slice(dial.length);
  }
  return `+${dial}${national}`;
}

/** Same rule as kio-api's PhoneNumberValidator for an international number. */
export function isValidInternationalPhone(value) {
  return /^\+\d{9,15}$/.test(String(value ?? ''));
}
